import {
    put, call, all, takeLatest, select
} from 'redux-saga/effects';
import { defaultSaga, getActions } from '../utils';

import * as constants from './constants';
import * as actions from './actions';
import * as api from './api';
import converter from './converter';

export default function* rootSaga() {
    yield all([
        yield takeLatest(
            constants.getCalculatorsDepth.toString(),
            defaultSaga({
                constants: constants.getCalculatorsDepth,
                api: api.getCalculatorsDepth
            })
        ),
        yield takeLatest(
            constants.getCalculatorsDepthItem.toString(),
            defaultSaga({
                constants: constants.getCalculatorsDepthItem,
                api: api.getCalculatorsDepthItem
            })
        )
    ]);
}